// extracted by mini-css-extract-plugin
module.exports = {"HCP_Search":"Search_HCP_Search__2Hufn","HCP_Search_Details":"Search_HCP_Search_Details__2Guiw"};